module.exports = __webpack_public_path__ + "img/shower.4e460315.png";